import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Refresh } from "iconsax-react";
const RefreshIconButton = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Tooltip title="Refresh Page">
      <IconButton
        onClick={handleRefresh}
        sx={{
          color: "#031634", // Icon color
          "&:hover": { color: "blue" }, // Hover color
        }}
      >
        <Refresh size="18" color="#FF8A65" />
      </IconButton>
    </Tooltip>
  );
};

export default RefreshIconButton;
